import React from 'react'
import  useIsMobile  from '../../hooks/useIsMobile'
import Modal from '../Modal'
import { ComponentContainer } from '../Modal/styled'
import { Title, Text1Bold, Text2 } from '../ui/text'
import { Button } from '../ui/button'
import theme from '../../styled/theme'
import { WhatsApp } from '../../assets/icons'
import { Section, InfoList, PhoneCard } from './styled'
import { handleContactAction } from '../../utils/contactActions'

const WHATSAPP_NUMBER = '+54 9 11 4493-2017'

const toList = value => (Array.isArray(value) ? value : value ? [value] : [])

const ModalOrderDetail = ({ order = {}, onClose }) => {
	const isMobile = useIsMobile()
	const info = toList(order.informacionAdicional)
	const prescriptor = order.prescriptor || order.profesional
	const procedimientos = Array.isArray(order.procedimientos)
		? order.procedimientos
		: toList(order.procedimientos).flatMap(item =>
				String(item)
					.split(',')
					.map(p => p.trim())
					.filter(Boolean)
		  )

	return (
		<Modal onClose={onClose} widthDesktop="522px" isFullHeight={isMobile}>
			<ComponentContainer $alignItems="stretch" $padding="18px 50px" style={{ gap: '18px', textAlign: 'left' }} isFullHeight={isMobile}>
				<Section $gap={isMobile ? '16px' : '20px'}>
				<Title size="24px" color={theme.colors.text.primaryText}>
					Orden médica{order.fecha ? ` - ${order.fecha}` : ''}
				</Title>

				{prescriptor && (
					<Section>
						<Text1Bold size="16px">Prescriptor</Text1Bold>
						<Text2 size="16px" color={theme.colors.text.secondaryText}>{prescriptor}</Text2>
					</Section>
				)}

				{procedimientos.length > 0 && (
					<Section>
						<Text1Bold size="16px">Procedimientos</Text1Bold>
						<InfoList>
							{procedimientos.map((procedimiento, index) => (
								<li key={index}>
									<Text2 size="16px" color={theme.colors.text.primaryText}>{procedimiento}</Text2>
								</li>
							))}
						</InfoList>
					</Section>
				)}
				</Section>
				{order.telefono && (
					<PhoneCard $isMobile={isMobile} >
						<Text1Bold size="16px" align="center" color={theme.colors.text.primaryText}>
							Consultá si el estudio puede realizarse en nuestras clínicas y reserva tu turno al:
						</Text1Bold>
						<Button
							$variant="secondary"
							label={WHATSAPP_NUMBER}
							iconLeft={<WhatsApp color="currentColor" />}
							onClick={() => handleContactAction({ type: 'whatsapp', value: WHATSAPP_NUMBER })}
						/>
					</PhoneCard>
				)}
			</ComponentContainer>
		</Modal>
	)
}

export default ModalOrderDetail
